import { END_POINTS } from '../helpers';
import { DamageData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetDamageResponse = {
  count: number;
  data: DamageData[];
};

export const gccApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDamage: builder.query<
      CommonResponse & { data: GetDamageResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getDamage}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteDamage: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteDamage}/${id}`,
        method: 'DELETE',
      }),
    }),
    getDamageById: builder.query<CommonResponse & { data: DamageData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getDamageById}/${id}`,
        method: 'GET',
      }),
    }),

    addDamage: builder.mutation<CommonResponse & { data: DamageData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addDamage}`,
        method: 'POST',
        body,
      }),
    }),
    updateDamage: builder.mutation<
      CommonResponse & { data: DamageData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateDamage}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddDamageMutation,
  useUpdateDamageMutation,
  useLazyGetDamageQuery,
  useLazyDeleteDamageQuery,
  useLazyGetDamageByIdQuery,
} = gccApi;
